// Used by the route's validateSearch outside the lazy page chunk, so this module stays free of components.

export const PRIVACY_TABS = ['einwilligungen', 'dokumente', 'loeschung', 'protokoll'] as const
export type PrivacyTab = (typeof PRIVACY_TABS)[number]
export type PrivacySearch = { tab?: PrivacyTab; person?: string }
